// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes circleMotion {
  /* Добавляем translate(-50%, -50%) в каждый шаг анимации */
  0%   { transform: translate(0px, 0px); }
  25%  { transform: translate(2px, -2px); }
  50%  { transform: translate(0px, -4px); }
  75%  { transform: translate(-2px, -2px); }
  100% { transform: translate(0px, 0px); }
}


.reserved-piece-container { 
  animation: circleMotion 4s infinite linear;
  pointer-events: none;
  scale: 0.8;
  opacity: 0.8;
  filter: grayscale(20%) drop-shadow(0 0 3px #ffffff9f)  drop-shadow(0 0 1px #ffffff9f);
}

.unreserved-piece-container {
  scale: 1;
  filter: none;
  opacity: 1;
}


/* Стили для имени пользователя (аналогично HighlightedPieces) */
.reserved-piece-name {
  /* Основные стили задаются inline в JS */
  pointer-events: none;
  text-align: center;
  min-width: 35px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/canvaspuzzle/components/pieces/ReservedPieces.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;EAC1D,OAAO,8BAA8B,EAAE;EACvC,OAAO,+BAA+B,EAAE;EACxC,OAAO,+BAA+B,EAAE;EACxC,OAAO,gCAAgC,EAAE;EACzC,OAAO,8BAA8B,EAAE;AACzC;;;AAGA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,UAAU;EACV,YAAY;EACZ,qFAAqF;AACvF;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,UAAU;AACZ;;;AAGA,gEAAgE;AAChE;EACE,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["@keyframes circleMotion {\r\n  /* Добавляем translate(-50%, -50%) в каждый шаг анимации */\r\n  0%   { transform: translate(0px, 0px); }\r\n  25%  { transform: translate(2px, -2px); }\r\n  50%  { transform: translate(0px, -4px); }\r\n  75%  { transform: translate(-2px, -2px); }\r\n  100% { transform: translate(0px, 0px); }\r\n}\r\n\r\n\r\n.reserved-piece-container { \r\n  animation: circleMotion 4s infinite linear;\r\n  pointer-events: none;\r\n  scale: 0.8;\r\n  opacity: 0.8;\r\n  filter: grayscale(20%) drop-shadow(0 0 3px #ffffff9f)  drop-shadow(0 0 1px #ffffff9f);\r\n}\r\n\r\n.unreserved-piece-container {\r\n  scale: 1;\r\n  filter: none;\r\n  opacity: 1;\r\n}\r\n\r\n\r\n/* Стили для имени пользователя (аналогично HighlightedPieces) */\r\n.reserved-piece-name {\r\n  /* Основные стили задаются inline в JS */\r\n  pointer-events: none;\r\n  text-align: center;\r\n  min-width: 35px;\r\n  white-space: nowrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
